import moment from 'moment';
import { IStringDictionary, StringDictionary } from '../../core/StringDictionary';

export enum LicenseActivationStatus {
    Activated, Canceled, Expired
}

export class LicenseActivation {
    constructor(licenseActivation?: ILicenseActivation) {
        this.courses = new StringDictionary();
        this.campusProfiles = new StringDictionary();
        if (licenseActivation) {
            this.licenseId = licenseActivation.licenseId;
            this.licenseIndex = licenseActivation.licenseIndex;
            this.activationIndex = licenseActivation.activationIndex;
            this.activationDate = licenseActivation.activationDate;
            this.expirationDate = licenseActivation.expirationDate;
            this.cancelationDate = licenseActivation.cancelationDate;
            this.secondsInUse = licenseActivation.secondsInUse;
            if (licenseActivation.courses)
                this.courses = new StringDictionary(licenseActivation.courses);
            this.userProfileId = licenseActivation.userProfileId;
            this.userFirstName = licenseActivation.userFirstName;
            this.userLastName = licenseActivation.userLastName;
            this.userEmail = licenseActivation.userEmail;
            this.classes = licenseActivation.classes;
            this.licenseId = licenseActivation.licenseId;
            if (licenseActivation.campusProfiles)
                this.campusProfiles = new StringDictionary(licenseActivation.campusProfiles);
        }
    }

    licenseId: number;
    licenseIndex: number;
    activationIndex: number;
    activationDate?: string;
    expirationDate?: string;
    cancelationDate?: string;
    secondsInUse: number;

    courses: StringDictionary;
    userProfileId: string;
    userFirstName: string;
    userLastName: string;
    userEmail: string;
    classes: string[];
    campusProfiles: StringDictionary;

    get status(): LicenseActivationStatus {
        return this.cancelationDate != null ? LicenseActivationStatus.Canceled :
            moment(this.expirationDate).toDate() < moment().startOf('day').toDate() ? LicenseActivationStatus.Expired :
                LicenseActivationStatus.Activated;
    }

    get statusDate() : string | undefined {
        return moment(this.expirationDate).toDate() < moment().startOf('day').toDate() ? this.expirationDate : this.activationDate;
    }
}

export interface ILicenseActivation {
    licenseId: number;
    licenseIndex: number;
    activationIndex: number;
    activationDate?: string;
    expirationDate?: string;
    cancelationDate?: string;
    secondsInUse: number;

    courses: IStringDictionary;
    userProfileId: string;
    userFirstName: string;
    userLastName: string;
    userEmail: string;
    classes: string[];
    campusProfiles: IStringDictionary;
}